import { render } from "./LoopText.vue?vue&type=template&id=6a18687b&scoped=true"
import script from "./LoopText.vue?vue&type=script&lang=js"
export * from "./LoopText.vue?vue&type=script&lang=js"

import "./LoopText.vue?vue&type=style&index=0&id=6a18687b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a18687b"]])

export default __exports__